import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba1e68cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "graph-container",
  ref: "graphContainer"
}
const _hoisted_2 = { class: "graph" }
const _hoisted_3 = {
  id: "q-graph",
  ref: "graph"
}
const _hoisted_4 = ["onMouseover"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "detail" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Register:", -1))
const _hoisted_8 = { class: "detail" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Goal Achieved:", -1))
const _hoisted_10 = { class: "detail" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Conversion:", -1))
const _hoisted_12 = { class: "detail" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Reward (THB):", -1))
const _hoisted_14 = {
  key: 0,
  class: "line-register"
}
const _hoisted_15 = { class: "line-chart" }
const _hoisted_16 = {
  key: 1,
  class: "line-goal"
}
const _hoisted_17 = { class: "line-chart" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"800"} }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"font-weight":"800"} }, "(THB)", -1))
const _hoisted_21 = [
  _hoisted_20
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataForRender, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: index,
              class: "qtr",
              style: _normalizeStyle({ left: `${_ctx.leftBar(index)}px` }),
              onMouseover: 
              (e) => {
                _ctx.overCursor(e);
                _ctx.dataSelect = item;
                _ctx.togglePopup = true;
              }
            ,
              onMouseleave: _cache[0] || (_cache[0] = 
              (e) => {
                _ctx.leaveCursor(e);
                _ctx.togglePopup = false;
              }
            )
            }, [
              _createElementVNode("th", {
                scope: "row",
                style: _normalizeStyle({ width: `${_ctx.widthBar}px` })
              }, [
                _createElementVNode("label", {
                  class: "label-vertical",
                  style: _normalizeStyle({ left: `${_ctx.widthBar / 2}px` })
                }, _toDisplayString(item.label), 5)
              ], 4),
              (_ctx.config.is_show_bar)
                ? (_openBlock(), _createElementBlock("td", {
                    key: 0,
                    class: "bar",
                    style: _normalizeStyle({
                height: `${_ctx.heightBar(item.reward)}px`,
                width: `${_ctx.widthBar}px`,
              })
                  }, null, 4))
                : _createCommentVNode("", true)
            ], 44, _hoisted_4))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["popup", { toggle: _ctx.togglePopup }]),
          style: _normalizeStyle({ left: `${_ctx.popupClientX}px`, top: `${_ctx.popupClientY}px` }),
          onMouseover: _cache[1] || (_cache[1] = 
            (e) => {
              _ctx.togglePopup = true;
            }
          ),
          onMouseleave: _cache[2] || (_cache[2] = 
            (e) => {
              _ctx.togglePopup = false;
            }
          )
        }, [
          _createElementVNode("p", null, " Campaign Result " + _toDisplayString(_ctx.$dayjs(_ctx.dataSelect?.label).format("DD/MM/YYYY")), 1),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", null, _toDisplayString(_ctx.addComma(_ctx.dataSelect?.register || 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("span", null, _toDisplayString(_ctx.addComma(_ctx.dataSelect?.goal_achieved || 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", null, _toDisplayString(_ctx.addComma(_ctx.dataSelect?.conversion || 0, { toFixed: 2 })) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("span", null, _toDisplayString(_ctx.addComma(_ctx.dataSelect?.reward || 0, { toFixed: 2 })), 1)
          ])
        ], 38),
        (_ctx.config.is_show_register_line)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("ul", _hoisted_15, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataRegisterForRender, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    style: _normalizeStyle({ '--x': `${item.x}px`, '--y': `${item.y}px` })
                  }, [
                    (_ctx.isShowLine(_ctx.dataRegisterForRender, index))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "register-line-segment",
                          style: _normalizeStyle({
                  '--hypotenuse': `${
                    _ctx.hypotenuse(_ctx.dataRegisterForRender, index)
                  }`,
                  '--angle': _ctx.angle(_ctx.dataRegisterForRender, index),
                })
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ], 4))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.config.is_show_goal_line)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("ul", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataGoalForRender, (item, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: index,
                    style: _normalizeStyle({ '--x': `${item.x}px`, '--y': `${item.y}px` })
                  }, [
                    (_ctx.isShowLine(_ctx.dataGoalForRender, index))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "goal-line-segment",
                          style: _normalizeStyle({
                  '--hypotenuse': `${
                    _ctx.hypotenuse(_ctx.dataGoalForRender, index)
                  }`,
                  '--angle': _ctx.angle(_ctx.dataGoalForRender, index),
                })
                        }, null, 4))
                      : _createCommentVNode("", true)
                  ], 4))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          id: "volume",
          style: _normalizeStyle({ height: `${_ctx.graphSize.height}px` })
        }, [
          _createElementVNode("div", {
            class: "volume",
            style: _normalizeStyle({ height: `${_ctx.lineHeightYAxisRight}px` })
          }, _hoisted_19, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineChartYAxisLeft, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "volume",
              style: _normalizeStyle({ height: `${_ctx.lineHeighYAxisLeft}px` })
            }, [
              _createElementVNode("p", null, _toDisplayString(item), 1)
            ], 4))
          }), 128))
        ], 4),
        _createElementVNode("div", {
          id: "thb",
          style: _normalizeStyle({
            width: `${_ctx.lineWidthYAxisRight}px`,
            height: `${_ctx.graphSize.height}px`,
          })
        }, [
          _createElementVNode("div", {
            class: "thb",
            style: _normalizeStyle({ height: `${_ctx.lineHeightYAxisRight}px` })
          }, _hoisted_21, 4),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lineChartYAxisRight, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "thb",
              style: _normalizeStyle({ height: `${_ctx.lineHeightYAxisRight}px` })
            }, [
              _createElementVNode("p", null, _toDisplayString(item), 1)
            ], 4))
          }), 128))
        ], 4)
      ], 512)
    ])
  ], 512))
}